import { useMemo } from 'react';

import { translate } from '@front/i18n';

import { mapOptionsNameToOptionsLabelFormat } from './utils';

const t = translate('screens.professional_status');

export const usePermitResidentType = (isOptionObjectWithLabel = false) => {
  const permitResidentTypeOptions = useMemo(
    () => [
      { name: t('.residence_permit_type.options.resident_card'), value: 'resident' },
      { name: t('.residence_permit_type.options.private_and_family'), value: 'private_and_family' },
      {
        name: t('.residence_permit_type.options.residence_permit_or_student_visa'),
        value: 'student',
      },
      {
        name: t('.residence_permit_type.options.residence_permit_withdraw_UK'),
        value: 'brexit_withdrawal_agreement',
      },
      {
        name: t('.residence_permit_type.options.certificate_algerian_residence'),
        value: 'algerian_certificate',
      },
      { name: t('.residence_permit_type.options.application_receipt'), value: 'renewal_or_receipt_of_application' },
      { name: t('.residence_permit_type.options.other'), value: 'other' },
    ],
    [],
  );

  const formattedPermitResidentTypeOptions = isOptionObjectWithLabel
    ? permitResidentTypeOptions.map(mapOptionsNameToOptionsLabelFormat)
    : permitResidentTypeOptions;

  return formattedPermitResidentTypeOptions;
};
